import 'css-chunksrc/client/pages/projectPage/exportsPage/wbsReport/sort/styles.scss';export default {
  "sort": "_sort_1ry6n_1",
  "label": "_label_1ry6n_9",
  "input": "_input_1ry6n_15",
  "placeholder": "_placeholder_1ry6n_31",
  "icon": "_icon_1ry6n_39",
  "listRoot": "_listRoot_1ry6n_47",
  "list": "_list_1ry6n_47",
  "item": "_item_1ry6n_63",
  "option": "_option_1ry6n_76",
  "selected": "_selected_1ry6n_83",
  "opened": "_opened_1ry6n_96"
};